var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestimonial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 53,
    viewBox: "0 0 71 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1723 11.621L25.2605 0.280029C16.3716 1.50608 10.0882 4.41794 6.1035 9.32212C2.11885 14.2263 0.279785 20.2033 0.279785 27.4063V53H30.4712V25.414H14.8391V24.6477C14.8391 21.2761 15.7586 18.3642 17.9042 16.2186C20.0498 14.073 23.4214 12.5405 28.1723 11.621ZM68.0188 11.621L64.9537 0.280029C56.2181 1.50608 49.9346 4.41794 45.95 9.32212C41.9654 14.2263 39.973 20.2033 39.973 27.4063V53H70.1644V25.414H54.6856V24.6477C54.6856 21.2761 55.6051 18.3642 57.7507 16.2186C59.8963 14.073 63.2679 12.5405 68.0188 11.621Z",
    fill: "#7E5CDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonial);
export default __webpack_public_path__ + "static/media/testimonial.9b23c1a9.svg";
export { ForwardRef as ReactComponent };